var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-text-input',{ref:"input",attrs:{"id":"table-search","label":_vm.label,"value":_vm.searchValue,"autofocus":_vm.autofocus},on:{"input":_vm.onSearchInput,"paste":_vm.onPaste},scopedSlots:_vm._u([{key:"append",fn:function(){return [_c('v-icon',[_vm._v("search")])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }